import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIncomingCall: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-incoming-call", jiraSpaEntry: "async-jira-eoc-incoming-call" */ '@jira/eoc__incoming-call/src/index.tsx'
	).then((module) => module.IncomingCallPage),
);

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyIncomingCallDetail: LazyComponent<any> = lazyForPaint<any>(() =>
	import(
		/* webpackChunkName: "async-jira-eoc-incoming-call-integration-detail", jiraSpaEntry: "async-jira-eoc-incoming-call-integration-detail" */ '@jira/eoc__incoming-call/src/index.tsx'
	).then((module) => module.IncomingCallDetailPage),
);
